import { CalendarDays, Plus } from "lucide-react";
import { AccountMenu } from "@/components/shell/AccountMenu";
import { WorkspaceHeader, type WorkspaceNavItem } from "@/components/shell/WorkspaceHeader";
import { TripForm } from "@/components/trip-form/TripForm";
import { useHasPermission } from "@/auth/usePermissions";

// =============================================================================
// /
//
// The default landing page once a user is signed in: the trip request
// form, under the full-width workspace bar (brand, New trip / Booked trips,
// account menu). The form lays itself out in two columns on wide screens —
// the steps on the left, a live trip summary on the right.
// =============================================================================

export function FormPage() {
  const canViewBooked = useHasPermission("viewBookedTrips");
  const nav: WorkspaceNavItem[] = [
    { to: "/", label: "New trip", icon: Plus, end: true },
    ...(canViewBooked ? [{ to: "/booked", label: "Booked trips", icon: CalendarDays }] : []),
  ];
  return (
    <>
      <WorkspaceHeader nav={nav} trailing={<AccountMenu />} />
      <main
        id="main-content"
        className="page-in mx-auto w-full max-w-[1280px] scroll-mt-16 px-4 pb-12 pt-6 sm:px-6 sm:pt-10"
      >
        <TripForm />
      </main>
    </>
  );
}
